import { TOnboardingConfig } from "../../../../app/models";
import { matchQuestionnaireDocuments } from "../../../utils/questionnaireDocumentMatching";
import { TUserFullInfo } from "../../../models";
import { PdfSection } from "./types";
import { buildSectionForDocument } from "./documentExporters";
import { DefaultSectionContext } from "./defaultSectionBuilder";
import { TResult } from "../../../hooks/useDocumentListWithData";

export type BuildQuestionnairePdfPlanParams = {
  onboardingConfig: TOnboardingConfig | null;
  documents: TResult;
  userInfo: TUserFullInfo;
  comments: Record<string, string>;
  countriesRegex: any;
  companyPurpose: string;
};

/**
 * Converts onboardingConfig + documents into ordered PdfSection[] (config steps first, then orphans).
 */
export function buildQuestionnairePdfPlan(
  params: BuildQuestionnairePdfPlanParams
): PdfSection[] {
  const {
    onboardingConfig,
    documents,
    userInfo,
    comments,
    countriesRegex,
    companyPurpose,
  } = params;
  const documentList = documents && documents.length > 0 ? documents : [];
  const elements = onboardingConfig?.elements ?? null;

  const { stepDocuments, orphanDocuments } = matchQuestionnaireDocuments(
    elements,
    documentList
  );

  const context: DefaultSectionContext = {
    userInfo,
    comments,
    countriesRegex,
    companyPurpose,
  };

  const sections: PdfSection[] = [];

  for (const { element, documents: matchedDocs } of stepDocuments) {
    for (const doc of matchedDocs) {
      sections.push(buildSectionForDocument(doc, element, context));
    }
  }

  for (const doc of orphanDocuments) {
    sections.push(buildSectionForDocument(doc, null, context));
  }

  return sections;
}
